// extracted by mini-css-extract-plugin
export var active = "artist-module--active--NeRXF artist-module--common--ZOijI";
export var common = "artist-module--common--ZOijI";
export var inactive = "artist-module--inactive--H17Cv artist-module--common--ZOijI colors-module--color-body--wh0CY";
export var listItem = "artist-module--list-item--m1er+ typography-module--body--LdsA5 typography-module--link--89r-u";
export var ul = "artist-module--ul--NYsuI";